import React, { Fragment } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { useTranslate, Edit, TextInput, SelectInput, DateInput, DateTimeInput, Toolbar, SaveButton } from 'react-admin';
import { Typography } from '@material-ui/core';
import { countriesForSelection, languagesForSelection } from '../../i18n/en.js';
import { SimpleForm } from 'ra-ui-materialui/lib/form';
import { toApiDateTimeFormat, toJavaScriptDateFormat } from '../../components/helper/DateHelper';
import Grid from '../../components/wrapper/Grid';
import UserEditActions from './UserEditActions';
import WalletList from '../wallets/WalletList';
import IdDocumentList from '../idDocuments/IdDocumentList';

export const styles = {
	edit: {
		marginBottom: 24
	},
	list: {
		marginBottom: 24
	},
	titles: {
		marginTop: 10,
		marginBottom: 20
	},
};

const UserEditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton />
    </Toolbar>
);

const UserEdit = ({ classes, ...props }) => {
	const translate = useTranslate();
	return (
		<Fragment>
			<Edit actions={<UserEditActions />} {...props} className={classes.edit}>
				<SimpleForm variant="standard" toolbar={<UserEditToolbar />}>
					<Grid container spacing={2}>
						<Grid item xs>
							<TextInput source="id" fullWidth disabled />
							<SelectInput
								source="gender"
								fullWidth
								choices={[
									{ id: 'M', name: 'coreWalletAdmin.common.gender.male' },
									{ id: 'F', name: 'coreWalletAdmin.common.gender.female' },
									{ id: 'U', name: 'coreWalletAdmin.common.gender.unknown' }
								]}
							/>
							<TextInput source="firstName" fullWidth />
							<TextInput source="lastName" fullWidth />
							<TextInput source="primaryEmail" fullWidth />
							<TextInput source="primaryPhoneNumber" fullWidth />
							<SelectInput
								source="language"
								choices={languagesForSelection}
								fullWidth
							/>
							<DateInput
								source="dateOfBirth"
								parse={value => toApiDateTimeFormat(value)}
								format={value => toJavaScriptDateFormat(value)}
								fullWidth
							/>
							<TextInput source="occupation" fullWidth />
							<TextInput source="birthPlace" fullWidth />
						</Grid>
						<Grid item xs>
							<SelectInput
								source="birthCountry"
								choices={countriesForSelection}
								fullWidth
							/>
							<SelectInput
								source="nationCode"
								choices={countriesForSelection}
								fullWidth
							/>
							<SelectInput
								source="citizenship"
								choices={countriesForSelection}
								fullWidth
							/>
							<TextInput source="personalNumber" fullWidth />
							<TextInput source="sourceOfIncome" fullWidth />
							<DateTimeInput source="creationDateTime" disabled fullWidth />
							<TextInput source="status" fullWidth disabled />
							<TextInput source="verificationLevel" fullWidth disabled />
							<TextInput source="roles" fullWidth disabled />
							<TextInput source="onWatchList" fullWidth disabled />
							<TextInput source="ipAddress" fullWidth disabled />
						</Grid>
					</Grid>
				</SimpleForm>
			</Edit>
			<Typography className={classes.titles} variant="h5">
				{translate('resources.wallets.name')}
			</Typography>
			<WalletList
				perPage={5}
				{...props}
				title=" "
				basePath={'/wallets'}
				resource={'wallets'}
				className={classes.list}
				filter={{ ownerType: 'User', ownerId: props.id }}
				hideOwnerFilter={true}
			/>
			<Typography className={classes.titles} variant="h5">
				{translate('resources.idDocuments.name')}
			</Typography>
			<IdDocumentList
				perPage={5}
				{...props}
				title=" "
				basePath="/idDocuments"
				resource="idDocuments"
				filter={{ userId: props.id }}
				className={classes.list}
			/>
		</Fragment>
	);
};

export default withStyles(styles)(UserEdit);
